/**
 * Splits a date-time value into a human-readable date and time string.
 * Usage: const { date, time } = formatDateTime(value);
 */
export function formatDateTime(value) {
  if (!value) return { date: "—", time: "" };
  const d = new Date(value);
  const date = d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true }).toUpperCase();
  return { date, time };
}
